import * as React from 'react';
import { Form, FormGroup, ControlLabel, FormControl, HelpBlock, Row, Col } from 'react-bootstrap';
import { IEmailSender, ITemplate, IRecipient, IFile, IEmailFormState } from '../../../Types';
import { Translate } from '../../../../../../../shared/LanguageService';
import SenderSelect from '../SenderSelect';
import DateTime from 'react-datetime';
import TemplateSelect from '../../TemplateSelect';
import RecipientSelect from '../../RecipientSelect';
import moment from 'moment';
import WysiwygEditor from '../../../../../../../components/common/editor/Editor';
import { IAttachment } from '../../../Types';

interface IProps {
    errors: any;
    state: IEmailFormState;
    senders: IEmailSender[];
    recipients: IRecipient[];
    templates: ITemplate[];
    files: IFile[];
    attachments: IAttachment[];
    onAttachmentUpload: (attachment: IAttachment) => void;
    onAttachmentDelete: (id: number) => void;
    onChange: (e: any) => void;
    onBodyChange: (body: string) => void;
    onDateTimeChange: (moment: any) => void;
    onSelectorChange: (e: any) => void;
    onImageUploaded: (reference: string, filename: string) => void;
    editorKey: number;
}

const EmailForm = (props: IProps) => {
    function errorExists(errors: any, key: string) {
        if (errors && errors[key]) {
            return true;
        }

        return false;
    }

    return (
        <Form>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <SenderSelect
                            onChange={props.onSelectorChange}
                            senders={props.senders}
                            sender={props.state.sender}
                            errors={props.errors}
                        />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <RecipientSelect
                            onChange={props.onSelectorChange}
                            recipients={props.recipients}
                            recipient={props.state.recipient}
                            errors={props.errors}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <FormGroup validationState={errorExists(props.errors, 'ccs') ? 'error' : null}>
                <ControlLabel>
                    {Translate('view-order/basic-order/modal/create-email/form/cc')}
                </ControlLabel>
                <FormControl
                    type="text"
                    name="cc"
                    value={props.state.cc}
                    onChange={props.onChange}
                />
                {props.errors && <HelpBlock>{props.errors.ccs}</HelpBlock>}
            </FormGroup>

            <Row>
                <Col md={6}>
                    <FormGroup validationState={errorExists(props.errors, 'when') ? 'error' : null}>
                        <ControlLabel>
                            {Translate('view-order/basic-order/modal/create-email/form/when')}
                        </ControlLabel>
                        <DateTime locale={moment.locale()} onChange={props.onDateTimeChange} />
                        {props.errors && <HelpBlock>{props.errors.when}</HelpBlock>}
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <TemplateSelect
                            onChange={props.onSelectorChange}
                            templates={props.templates}
                            template={props.state.template}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <FormGroup
                className="required"
                validationState={errorExists(props.errors, 'subject') ? 'error' : null}
            >
                <ControlLabel>
                    {Translate('view-order/basic-order/modal/create-email/form/subject')}
                </ControlLabel>
                <FormControl
                    type="text"
                    name="subject"
                    required
                    value={props.state.subject}
                    onChange={props.onChange}
                />
                {props.errors && <HelpBlock>{props.errors.subject}</HelpBlock>}
            </FormGroup>

            <WysiwygEditor
                onChange={props.onBodyChange}
                content={props.state.body}
                height={200}
                files={props.files}
                attachments={props.attachments}
                onAttachmentUpload={props.onAttachmentUpload}
                onAttachmentDelete={props.onAttachmentDelete}
                onImageUploaded={props.onImageUploaded}
                addImageModal={false}
            />
        </Form>
    );
};

export default EmailForm;
